module.exports = __webpack_public_path__ + "static/spieltherapie-639101774d7f7bfa2bb94e2807c5c74d.jpg";